(function () {
    'use strict';
    var root = document.querySelector('.uf-project-inquiry[data-inquiry-form]');
    if (!root) return;
    var form = root.querySelector('#uf-form');
    var combos = Array.from(form.querySelectorAll('.uf-combo'));
    var requiredFields = ['service', 'description', 'budget', 'timeline', 'name', 'email'];
    var fields = {
      service: form.querySelector('[data-combo="service"] input'),
      description: form.querySelector('#uf-description'),
      budget: form.querySelector('[data-combo="budget"] input'),
      timeline: form.querySelector('[data-combo="timeline"] input'),
      name: form.querySelector('#uf-name'),
      email: form.querySelector('#uf-email'),
      url: form.querySelector('#uf-url')
    };
    form.querySelectorAll('.uf-native-fallback:not(.uf-conditional-select)').forEach(function (select) {
      select.disabled = true;
      form.querySelector('label[for="' + select.id + '"]').htmlFor = select.id.replace('-native','-button');
    });
    combos.forEach(function (combo) {
      combo.querySelector('input[type="hidden"]').name = combo.querySelector('input[type="hidden"]').dataset.name;
    });
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (name) {
      form.elements[name].value = new URLSearchParams(location.search).get(name) || '';
    });
    function fieldControl(name) {
      var field = form.querySelector('[data-field="' + name + '"]');
      return field.querySelector('.uf-combo__button') || field.querySelector('input:not([type="hidden"]),textarea');
    }
    function clearResult() {
      var result = form.querySelector('.uf-form-result');
      if (result) result.hidden = true;
    }
    function setError(name, message) {
      var field = form.querySelector('[data-field="' + name + '"]');
      var error = field.querySelector('.uf-error');
      error.textContent = message || error.textContent;
      field.classList.add('uf-has-error');
      fieldControl(name).setAttribute('aria-invalid', 'true');
    }
    function clearError(name) {
      var field = form.querySelector('[data-field="' + name + '"]');
      field.classList.remove('uf-has-error');
      fieldControl(name).removeAttribute('aria-invalid');
      if (!form.querySelector('.uf-has-error')) form.querySelector('#uf-error-summary').hidden = true;
    }
    function closeCombo(combo) {
      combo.querySelector('.uf-combo__button').setAttribute('aria-expanded', 'false');
      combo.querySelector('.uf-combo__button').removeAttribute('aria-activedescendant');
      combo.querySelector('.uf-combo__panel').hidden = true;
      combo.querySelectorAll('.uf-active').forEach(function (el) {el.classList.remove('uf-active');});
    }
    function positionCombo(combo) {
      var panel = combo.querySelector('.uf-combo__panel');
      var control = combo.querySelector('.uf-combo__button').getBoundingClientRect();
      var viewport = window.visualViewport;
      var viewportTop = viewport ? viewport.offsetTop : 0;
      var viewportBottom = viewportTop + (viewport ? viewport.height : window.innerHeight);
      var header = document.querySelector('[data-ufc-header]');
      if (header) viewportTop = Math.max(viewportTop, header.getBoundingClientRect().bottom);
      var below = Math.max(0, viewportBottom - control.bottom - 15);
      var above = Math.max(0, control.top - viewportTop - 15);
      var placeAbove = below < 330 && above > below;
      panel.style.top = placeAbove ? 'auto' : '';
      panel.style.bottom = placeAbove ? 'calc(100% + 6px)' : '';
      combo.querySelector('.uf-combo__options').style.maxHeight =
        Math.max(44, Math.min(354, (placeAbove ? above : below) - 12)) + 'px';
    }
    function repositionOpenCombos() {
      combos.forEach(function (combo) {
        if (combo.querySelector('.uf-combo__button').getAttribute('aria-expanded') === 'true') positionCombo(combo);
      });
    }
    function openCombo(combo) {
      combos.forEach(function (other) {if (other !== combo) closeCombo(other);});
      combo.querySelector('.uf-combo__panel').hidden = false;
      combo.querySelector('.uf-combo__button').setAttribute('aria-expanded', 'true');
      var options = Array.from(combo.querySelectorAll('[role="option"]'));
      var index = Math.max(0, options.findIndex(function (option) {return option.getAttribute('aria-selected') === 'true';}));
      positionCombo(combo);
      activate(combo, index);
    }
    function activate(combo, index) {
      var options = Array.from(combo.querySelectorAll('[role="option"]'));
      options.forEach(function (option) {option.classList.remove('uf-active');});
      var active = options[Math.max(0, Math.min(options.length - 1, index))];
      active.classList.add('uf-active');
      combo.querySelector('.uf-combo__button').setAttribute('aria-activedescendant', active.id);
      var list = combo.querySelector('.uf-combo__options');
      var activeBox = active.getBoundingClientRect();
      var listBox = list.getBoundingClientRect();
      if (activeBox.top < listBox.top) list.scrollTop -= listBox.top - activeBox.top;
      else if (activeBox.bottom > listBox.bottom) list.scrollTop += activeBox.bottom - listBox.bottom;
    }
    function updateConditional(service) {
      form.querySelectorAll('[data-condition]').forEach(function (section) {
        var show = section.dataset.condition === service;
        section.hidden = !show;
        section.querySelectorAll('input,select').forEach(function (control) {
          control.disabled = !show;
          if (!show) control.value = '';
        });
      });
    }
    function choose(combo, option) {
      var name = combo.dataset.combo;
      var value = option.dataset.value;
      combo.querySelector('input[type="hidden"]').value = value;
      var label = option.querySelector('.uf-option__title');
      var valueNode = combo.querySelector('.uf-combo__value');
      valueNode.textContent = label ? label.textContent : option.textContent.trim();
      valueNode.classList.remove('uf-combo__value--placeholder');
      if (option.dataset.icon) combo.querySelector('.uf-combo__button .uf-icon use').setAttribute('href', '#' + option.dataset.icon);
      combo.querySelectorAll('[role="option"]').forEach(function (other) {
        other.setAttribute('aria-selected', other === option ? 'true' : 'false');
      });
      closeCombo(combo);
      combo.querySelector('.uf-combo__button').focus();
      if (name === 'service') updateConditional(value);
      if (requiredFields.includes(name)) clearError(name);
      clearResult();
    }
    combos.forEach(function (combo) {
      var button = combo.querySelector('.uf-combo__button');
      var options = Array.from(combo.querySelectorAll('[role="option"]'));
      button.addEventListener('click', function () {
        if (button.getAttribute('aria-expanded') === 'true') closeCombo(combo);
        else openCombo(combo);
      });
      button.addEventListener('keydown', function (event) {
        var open = button.getAttribute('aria-expanded') === 'true';
        var current = options.findIndex(function (option) {return option.classList.contains('uf-active');});
        if (['ArrowDown','ArrowUp','Home','End'].includes(event.key)) {
          event.preventDefault();
          if (!open) {openCombo(combo);return;}
          if (event.key === 'Home') activate(combo,0);
          if (event.key === 'End') activate(combo,options.length - 1);
          if (event.key === 'ArrowDown') activate(combo,(current + 1) % options.length);
          if (event.key === 'ArrowUp') activate(combo,(current - 1 + options.length) % options.length);
        } else if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          if (!open) openCombo(combo);
          else choose(combo,options[Math.max(0,current)]);
        } else if (event.key === 'Escape' && open) {
          event.preventDefault();closeCombo(combo);
        } else if (event.key === 'Tab' && open) closeCombo(combo);
      });
      combo.querySelector('.uf-combo__options').addEventListener('click', function (event) {
        var option = event.target.closest('[role="option"]');
        if (option) choose(combo,option);
      });
      combo.querySelector('.uf-combo__options').addEventListener('mousemove', function (event) {
        var option = event.target.closest('[role="option"]');
        if (option && !option.classList.contains('uf-active')) activate(combo,options.indexOf(option));
      });
    });
    document.addEventListener('pointerdown', function (event) {
      combos.forEach(function (combo) {if (!combo.contains(event.target)) closeCombo(combo);});
    });
    window.addEventListener('resize', repositionOpenCombos, {passive:true});
    window.addEventListener('scroll', repositionOpenCombos, {passive:true});
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', repositionOpenCombos, {passive:true});
      window.visualViewport.addEventListener('scroll', repositionOpenCombos, {passive:true});
    }
    ['description','name','email','url'].forEach(function (name) {
      fields[name].addEventListener('input', function () {
        clearError(name);clearResult();
      });
    });
    function validUrl(value) {
      try {var url = new URL(value);return ['http:','https:'].includes(url.protocol) && url.hostname.includes('.');}
      catch (error) {return false;}
    }
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearResult();
      requiredFields.concat(['url']).forEach(clearError);
      var invalid = [];
      requiredFields.forEach(function (name) {
        if (!fields[name].value.trim()) {
          invalid.push(name);
          setError(name,{
            service:'Choose what you’re looking to do.',
            description:'Tell us a little about your project.',
            budget:'Choose a budget range, or select “Not sure yet.”',
            timeline:'Choose when you’re looking to get started.',
            name:'Enter your name.',
            email:'Enter your email address.'
          }[name]);
        }
      });
      if (fields.email.value.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fields.email.value.trim())) {
        if (!invalid.includes('email')) invalid.push('email');
        setError('email','Enter a valid email address.');
      }
      if (fields.url.value.trim() && !validUrl(fields.url.value.trim())) {
        invalid.push('url');setError('url','Enter a complete URL, such as https://yourstore.com.');
      }
      if (invalid.length) {
        form.querySelector('#uf-error-summary').hidden = false;
        fieldControl(invalid[0]).focus();
        return;
      }
      ['service','budget','timeline','source'].forEach(function (key) { var native = form.querySelector('#uf-' + key + '-native'); if (native) { native.value = form.querySelector('[data-combo="' + key + '"] input').value; native.disabled = false; } });
      var body = form.querySelector('[name="contact[body]"]');
      body.value = 'Service: ' + (form.querySelector('[data-combo="service"] .uf-combo__value').textContent.trim() || fields.service.value) + '\n'
        + 'Project: ' + fields.description.value.trim() + '\n'
        + 'Budget: ' + (form.querySelector('[data-combo="budget"] .uf-combo__value').textContent.trim()) + '\n'
        + 'Timeline: ' + (form.querySelector('[data-combo="timeline"] .uf-combo__value').textContent.trim()) + '\n'
        + 'Website: ' + fields.url.value.trim() + '\n'
        + 'Company: ' + form.querySelector('#uf-company').value.trim() + '\n'
        + 'Platform: ' + form.querySelector('#uf-platform').value + '\n'
        + 'Growth goal: ' + form.querySelector('#uf-growth-goal').value + '\n'
        + 'Integration goal: ' + form.querySelector('#uf-integration').value + '\n'
        + 'Source: ' + form.querySelector('#uf-source-native').value + '\n'
        + 'Campaign: ' + ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].map(function(k){return k + '=' + form.elements[k].value;}).join(', ');
      var button = form.querySelector('.uf-submit');
      button.disabled = true;
      button.classList.add('uf-is-loading');
      button.querySelector('span').textContent = 'Submitting…';
      HTMLFormElement.prototype.submit.call(form);
    });
    updateConditional('');
    form.querySelector('.uf-submit').disabled = false;
    root.classList.add('uf-js');
  })();
